/**
 * referral.js - Centralized Broker Referral & Affiliate Links
 * Configure via REACT_APP_DELTA_REFERRAL_URL in .env
 */

export const DELTA_REFERRAL_URL = process.env.REACT_APP_DELTA_REFERRAL_URL || "https://india.delta.exchange";
